import { FormExtractorService } from '../../../shared/services/form-extractor.service';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_813 implements Validator {

	public static id = 'CTRL_813';
	private message = 'error.ctr_813';


	public LOG: LogService = new LogService(CTRL_813);
	public formExtractorService: FormExtractorService = new FormExtractorService();


	validate(form: any, map) {


		// vérifier si la règle est applicable sur mon formulaire
		const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_813.id + '_');


		if (rgs.length > 0) {
			for (const rg of rgs) {
				const ctrl = form.controls[rg];
				const dateJusquauWithStepId = map.get(ctrl.value.rgCtrls.date);
				const dateCtrl = form.controls[dateJusquauWithStepId];

				if (this.isFerieOrSunday(dateCtrl.value)) {
					// placer le message d'erreur
					form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
				} else {
					form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
				}
			}
		}
	}

	isFerieOrSunday(value) {
		const an = new Date(value).getFullYear();
		const JourAn = new Date(an, 0, 1).getTime();
		const FeteTravail = new Date(an, 4, 1).getTime();
		const Victoire1945 = new Date(an, 4, 8).getTime();
		const FeteNationale = new Date(an, 6, 14).getTime();
		const Assomption = new Date(an, 7, 15).getTime();
		const Toussaint = new Date(an, 10, 1).getTime();
		const Armistice = new Date(an, 10, 11).getTime();
		const Noel = new Date(an, 11, 25).getTime();
		const SaintEtienne = new Date(an, 11, 26).getTime();

		const G = an % 19;
		const C = Math.floor(an / 100);
		const H = (C - Math.floor(C / 4) - Math.floor((8 * C + 13) / 25) + 19 * G + 15) % 30;
		const I = H - Math.floor(H / 28) * (1 - Math.floor(H / 28) * Math.floor(29 / (H + 1)) * Math.floor((21 - G) / 11));
		const J = (an * 1 + Math.floor(an / 4) + I + 2 - C + Math.floor(C / 4)) % 7;
		const L = I - J;
		const MoisPaques = 3 + Math.floor((L + 40) / 44);
		const JourPaques = L + 28 - 31 * Math.floor(MoisPaques / 4);
		const Paques = new Date(an, MoisPaques - 1, JourPaques).getTime();
		const VendrediSaint = new Date(an, MoisPaques - 1, JourPaques - 2).getTime();
		const LundiPaques = new Date(an, MoisPaques - 1, JourPaques + 1).getTime();
		const Ascension = new Date(an, MoisPaques - 1, JourPaques + 39).getTime();
		const Pentecote = new Date(an, MoisPaques - 1, JourPaques + 49).getTime();
		const LundiPentecote = new Date(an, MoisPaques - 1, JourPaques + 50).getTime();

		const feries = new Array(JourAn, VendrediSaint, Paques, LundiPaques, FeteTravail, Victoire1945, Ascension, Pentecote, LundiPentecote, FeteNationale, Assomption, Toussaint, Armistice, Noel, SaintEtienne);
		const valueDate = new Date(value);
		valueDate.setHours(0, 0, 0, 0);
		return (feries.indexOf(valueDate.getTime()) !== -1 || valueDate.getDay() === 0);
	}
}
